import i18n from 'i18n';
import { dateFilterParams } from '../../../shared/constants/index';

export default [
  {
    headerName: i18n.t('audit.generalAudit.grid.responseStatus'),
    field: 'respStatus',
    sortable: true,
    filter: 'agNumberColumnFilter',
    floatingFilter: true,
    resizable: true,
  },
  {
    headerName: i18n.t('audit.generalAudit.grid.userName'),
    field: 'userName',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
  },
  {
    headerName: i18n.t('audit.generalAudit.grid.httpMethod'),
    field: 'httpMethod',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
  },
  {
    headerName: i18n.t('audit.generalAudit.grid.url'),
    field: 'url',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
  },
  {
    headerName: i18n.t('audit.generalAudit.grid.id'),
    field: 'id',
    sortable: true,
    filter: 'agNumberColumnFilter',
    floatingFilter: true,
    resizable: true,
  },
  {
    headerName: i18n.t('audit.generalAudit.grid.ipAddress'),
    field: 'ipAddress',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
  },
  {
    headerName: i18n.t('audit.generalAudit.grid.requestBody'),
    field: 'reqBody',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
  },
  {
    headerName: i18n.t('audit.generalAudit.grid.requestParameters'),
    field: 'reqParams',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
  },
  {
    headerName: i18n.t('audit.generalAudit.grid.requestTime'),
    field: 'reqTime',
    sortable: true,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    resizable: true,
    filterParams: dateFilterParams,
    cellRenderer: 'datetimeCellRenderer',
  },
  {
    headerName: i18n.t('audit.generalAudit.grid.sessionId'),
    field: 'sessionId',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
  },
];
